<template>
  <div class="sidebar-link">
    <Tooltip
      v-for="(item, idx) of withRoleItems"
      :key="idx"
      :text="item.title"
      scrolling
      position="right"
      :offset="[15, 15]"
      :disabled="!isRollup"
      :ui="{ anchor: 'sidebar-link__tooltip' }"
    >
      <div
        :class="[
          'sidebar-link__item',
          { 'sidebar-link__item_passive': isRollup },
          {
            'sidebar-link__item_active-link':
              activeBasket && item.icon === 'trash',
          },
        ]"
        @click="item.fn"
      >
        <Icon
          :value="item.icon"
          :ui="{ icon: 'sidebar-link__item-icon' }"
        />
        <h6 class="sidebar-link__item-text">
          {{ item.title }}
        </h6>
      </div>
    </Tooltip>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Icon } from '~packages/epk-front-shared/ui';

import getConstants from '@/shared/constants';
import { downloadByUrl } from '@/shared/helpers';
import { useModalNotification, useRightStore } from '@/shared/model';
import { useRoutes } from '@/shared/routes';
import { Tooltip } from '@/shared/ui';

const modalNotification = useModalNotification();

const { appBasePath } = getConstants();
const store = useRightStore();

const router = useRouter();
const route = useRoute();

const props = defineProps({
  notShowHint: {
    type: String,
    default: '',
  },
});

const isRollup = computed(() => props.notShowHint === 'passive');

const activeBasket = computed(() => route.name === useRoutes.BASKET_LIST_NAME);

const withRoleItems = computed(() =>
  !store.hasRightWrite ? items.filter(item => !item.needRole) : items
);

const items = [
  {
    title: 'Корзина',
    icon: 'trash',
    needRole: true,
    fn: () => onBasketClick(),
  },
  {
    title: 'Поддержка и инструкция',
    icon: 'phone',
    needRole: false,
    fn: () => onSupportClick(),
  },
  {
    title: 'Политика конфиденциальности',
    icon: 'lock',
    needRole: false,
    fn: () => onPrivacyClick(),
  },
];

//TODO лучше сделать модалку изменений на глобольном уровне
const onBasketClick = async () => {
  modalNotification.checkChanges();
  if (modalNotification.isModalActive || activeBasket.value) return;

  await router.push({
    name: useRoutes.BASKET_LIST_NAME,
    params: {
      entity: 'epks',
    },
    query: route.query,
  });
};

const onSupportClick = async () => {
  return window.open('https://epk.mcx.ru/manual/');
};

// const onManualClick = () => {
//   downloadByUrl(
//     appBasePath + 'docs/Руководство_пользователя_ЭПК.docx',
//     'Руководство пользователя ЭПК.docx'
//   );
// };

const onPrivacyClick = () => {
  downloadByUrl(
    appBasePath + 'docs/Политика_конфиденциальности_ЭПК.docx',
    'Политика конфиденциальности ЭПК.docx'
  );
};
</script>

<style lang="scss">
@import './EpkLinks';
</style>
